import {
  CalendarAddAlt,
  Close,
  Edit,
  EventSchedule,
  ListCheckedMirror,
  SplitScreen,
} from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import useNavigateTo from "../../../hooks/useNavigateTo";
import { InboundDeliveryAction } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { sortedDeliveryActions } from "../../../utils/helper";
import FallbackComponent from "../../fallbackComponent/FallbackComponent";
import DeliveryAction from "../deliveryAction/DeliveryAction";
import DeliveryActionCancel from "../deliveryAction/variants/DeliveryActionCancel";
import DeliveryActionCancelTimeSlot from "../deliveryAction/variants/DeliveryActionCancelTimeSlot";

interface DeliveryActionsListProps {
  actions: InboundDeliveryAction[];
  deliveryId: string;
}

const DeliveryActionsList = (props: DeliveryActionsListProps) => {
  const { t } = useTranslation();
  const {
    navigateToEditOrder,
    navigateToSplitOrder,
    navigateToConfirmQuantities,
    navigateToConfirmDate,
    navigateToBookTimeSlot,
  } = useNavigateTo();

  const { actions, deliveryId } = props;

  const sortedActions = sortedDeliveryActions(actions);

  const renderElementFromAction = (
    action: InboundDeliveryAction,
    index: number,
  ) => {
    switch (action) {
      case InboundDeliveryAction.CanBookTimeSlot:
        return (
          <DeliveryAction
            key={index}
            icon={<CalendarAddAlt size={24} />}
            label={t("bookTimeslot")}
            onClick={() => navigateToBookTimeSlot(deliveryId)}
          />
        );
      case InboundDeliveryAction.CanConfirmQuantities:
        return (
          <DeliveryAction
            key={index}
            icon={<ListCheckedMirror size={24} />}
            label={t("confirmQuantities")}
            onClick={() => navigateToConfirmQuantities(deliveryId)}
          />
        );
      case InboundDeliveryAction.CanConfirmDeliveryDate:
        return (
          <DeliveryAction
            key={index}
            icon={<EventSchedule size={24} />}
            label={t("confirmDeliveryDate")}
            onClick={() => navigateToConfirmDate(deliveryId)}
          />
        );
      case InboundDeliveryAction.CanEdit:
        return (
          <DeliveryAction
            key={index}
            icon={<Edit size={24} />}
            label={t("editInboundDelivery")}
            onClick={() => navigateToEditOrder(deliveryId)}
          />
        );
      case InboundDeliveryAction.CanSplit:
        return (
          <DeliveryAction
            key={index}
            icon={<SplitScreen size={24} />}
            label={t("splitInboundDelivery")}
            onClick={() => navigateToSplitOrder(deliveryId)}
          />
        );
      case InboundDeliveryAction.CanCancelTimeSlot:
        return (
          <DeliveryActionCancelTimeSlot key={index} deliveryId={deliveryId} />
        );
      case InboundDeliveryAction.CanCancel:
        return <DeliveryActionCancel key={index} id={deliveryId} />;
      default:
        return <>{t("notImplemented")}</>;
    }
  };

  if (!sortedActions || sortedActions.length === 0) {
    return (
      <FallbackComponent
        middleIcon={<Close size={32} />}
        text={t("noActionsExist")}
      />
    );
  }

  return (
    <>
      {sortedActions.map((actionElement, index) => {
        return renderElementFromAction(actionElement, index);
      })}
    </>
  );
};

//#endregion

export default DeliveryActionsList;
